import styled from 'styled-components'
import { Col } from 'react-styled-flexboxgrid-tmp'

import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'
import { BUILDING_HERO_HEIGHT_V3, BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'

export const _HeroContainer = styled.div`
  border-radius: 0 10px 10px 0;
  overflow: hidden;
  min-height: ${BUILDING_HERO_HEIGHT_V3};
  max-height: ${BUILDING_HERO_HEIGHT_V3};
  cursor: pointer;
  width: 66%;
  position: absolute;
  right: 0;
  top: 0;
  img {
    margin-bottom: -4px;
    min-height: ${BUILDING_HERO_HEIGHT_V3};
    max-height: ${BUILDING_HERO_HEIGHT_V3};
  }

  div [for="imagePlaceholder"] {
    overflow: visible !important;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 57%;
  }
  @media screen and (max-width: 900px) {
    width: 46%;
    min-height: 510px;
    max-height: 510px;
    img {
      min-height: 510px;
      max-height: 510px;
    }
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    min-height: calc(${BUILDING_HERO_HEIGHT_V3} / 2 + 14px);
    max-height: calc(${BUILDING_HERO_HEIGHT_V3} / 2 + 14px);
    img {
      min-height: calc(${BUILDING_HERO_HEIGHT_V3} / 2 + 14px);
      max-height: calc(${BUILDING_HERO_HEIGHT_V3} / 2 + 14px);
    }
    width: 100%;
    border-radius: 0;
    position: relative;
  }
`

export const _HeroImageContainer = styled(NoMarginRow)`
  @media screen and (max-width: 1023px) {
    margin: 0;
    img {
      min-width: initial;
    }
    &:hover {
      cursor: pointer;
    }
  }
`

/* Home and Area links */

export const _BgHeroImage = styled.div.attrs(() =>
  ({ className: 'lazyload' }))`
  img {
    object-fit: cover;
  }
  width: 100%;
  padding: 0 !important;
  @media screen and (min-width: 1440px) {
  }
`

export const _PlaceHolderImageHolder = styled(Col)`
  width: 100%;
  img {
    object-fit: cover;
  }
  @media screen and (max-width: 47.9em) {
    height: 330px;
  }
`

export const _SliderHolder = styled(NoMarginRow)`
`

export const _Counter = styled.div`
  width: 49px;
  height: 22px;
  position: absolute;
  bottom: 12px;
  right: 12px;
  background: rgba(16, 16, 16, 0.6);
  color: white;
  border-radius: 2px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 14px;
  svg {
    margin-right: 5px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    bottom: 17px;
  }
`
